/**
 * Branded 404 — replaces expo-router's stock "Unmatched Route" fallback
 * (plain black screen, generic file icon, default blue links, no theme
 * awareness). Uses the same BeroMark-watermarked EmptyState pattern as the
 * admin "Admins only" screen. See audit 05-admin-crosscutting.md P1-3.
 *
 * No TopBar here, so per the safe-area rule this screen owns its own top
 * inset via Screen's `safeTop`.
 */
import { router } from 'expo-router';
import React from 'react';

import { Icon } from '@/features/account-admin/icons';
import { useT } from '@/i18n';
import { useTheme } from '@/theme';
import { EmptyState, Screen } from '@/ui';

export default function NotFoundScreen() {
  const { t } = useT();
  const { colors } = useTheme();
  return (
    <Screen safeTop>
      <EmptyState
        icon={<Icon name="search" size={40} color={colors.textTertiary} />}
        title={t('nf_title')}
        body={t('nf_body')}
        cta={t('back_to_home')}
        onCta={() => router.replace('/home')}
      />
    </Screen>
  );
}
